import getV10APIs from './v1.0';
import getV11APIs from './v1.1';
import getV12APIs from './v1.2';
import { mergeVersionsByTitle } from '../../../util/HelperFunctions';

const data = (userInfo) => {
  const v10APIs = getV10APIs(userInfo);
  const v11APIs = getV11APIs(userInfo);
  const v12APIs = getV12APIs(userInfo);

  const children = [
    mergeVersionsByTitle('작업 등록', v12APIs, v11APIs),
    mergeVersionsByTitle('선택작업 등록', v11APIs, v10APIs),
    mergeVersionsByTitle('배송상태 업데이트', v11APIs),
    mergeVersionsByTitle('작업결과 조회', v10APIs),
    mergeVersionsByTitle('작업리스트 조회', v10APIs),
    mergeVersionsByTitle('작업 삭제', v11APIs)
  ].filter(Boolean);

  return { title: '작업', children };
};

export default data;
